// Canal de avisos NO bloqueantes de la maquinaria offline. Usos actuales:
//  - fotos descartadas por el ciclo de descarte controlado
//    (offlineSyncClient), y
//  - recordatorio de pendientes >24h y detalle borrado en el portal
//    (useOfflineSync).
//
// Un alert() en esos contextos congelaría el event loop en plena pasada de
// sync — con leases adquiridos que caducarían y el SW los robaría en caliente,
// que es justo la carrera que el lease elimina.
//
// Store mínimo con el mismo patrón subscribe/snapshot de useOfflineSync. Los
// avisos viven en memoria durante la sesión hasta que el usuario los cierra; el
// registro PERMANENTE del descarte va por Sentry, que se emite en el mismo
// punto.
//
// Se guarda la CLAVE i18n + sus parámetros, no el texto: los avisos los genera
// código sin React (el flush de la cola) y así se traducen en el render — y
// siguen al usuario si cambia de idioma con un aviso abierto.
import { useSyncExternalStore } from 'react';

export interface DiscardNotice {
  id: number;
  i18nKey: string;
  params?: Record<string, string | number>;
  at: number;
}

let notices: DiscardNotice[] = [];
let nextId = 1;
const subscribers = new Set<() => void>();

function emit(): void {
  subscribers.forEach((cb) => {
    try { cb(); } catch { /* subscriber roto */ }
  });
}

export function addDiscardNotice(i18nKey: string, params?: Record<string, string | number>): void {
  notices = [...notices, { id: nextId++, i18nKey, params, at: Date.now() }];
  emit();
}

export function dismissDiscardNotice(id: number): void {
  notices = notices.filter((n) => n.id !== id);
  emit();
}

function subscribe(cb: () => void): () => void {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}

export function useDiscardNotices(): DiscardNotice[] {
  return useSyncExternalStore(subscribe, () => notices, () => notices);
}
